import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["loginButton", "loginForm", "installButton"];

  connect() {
    this.installPromptEvent = null;
    this.installAppButtonCanAppear = "no";

    // Observe class changes on the login form
    this.observer = new MutationObserver(this.handleClassChange.bind(this));
    this.observer.observe(this.loginFormTarget, { attributes: true });

    // Listen for beforeinstallprompt event
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      this.installPromptEvent = e;
      this.installAppButtonCanAppear = "yes";
      this.installButtonTarget.classList.remove("hidden");
      this.loginButtonTarget.style.background = "#fff";
      this.loginButtonTarget.style.color = "#000";
    });
  }

  handleClassChange(mutationsList) {
    mutationsList.forEach((mutation) => {
      if (mutation.attributeName === "class") {
        if (this.installAppButtonCanAppear === "yes" && this.installButtonTarget.classList.contains("hidden")) {
          this.installButtonTarget.classList.remove("hidden");
        } else {
          this.installButtonTarget.classList.add("hidden");
        }
      }
    });
  }

  async installApp() {
    if (this.installPromptEvent) {
      this.installPromptEvent.prompt();
      const choice = await this.installPromptEvent.userChoice;
      this.installPromptEvent = null;

      // Hide button and disconnect observer
      this.installButtonTarget.classList.add("hidden");
      this.loginButtonTarget.style.background = "rgb(83, 207, 71)";
      this.loginButtonTarget.style.color = "#fff";
      this.observer.disconnect();
    }
  }
}
